import { render, staticRenderFns } from "./ViewProvinceCity2.vue?vue&type=template&id=6e283767&scoped=true&"
import script from "./ViewProvinceCity2.vue?vue&type=script&lang=js&"
export * from "./ViewProvinceCity2.vue?vue&type=script&lang=js&"
import style0 from "./ViewProvinceCity2.vue?vue&type=style&index=0&id=6e283767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e283767",
  null
  
)

export default component.exports